import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer as ToastContainerToastify } from 'react-toastify';
import { EVENTS } from './toastEvents';
import { showAlertToast, showSuccessToast } from './Toast';

const handleEvent = event => {
  switch (event.type) {
    case EVENTS.ALERT:
      showAlertToast(event.detail.title, event.detail.text, event.detail.options);
      break;
    case EVENTS.SUCCESS:
      showSuccessToast(event.detail.title, event.detail.text, event.detail.options);
      break;
    default:
      break;
  }
};

const ToastContainer = ({ className }) => {
  useEffect(() => {
    Object.values(EVENTS).forEach(event => {
      document.addEventListener(event, handleEvent);
    });

    return () =>
      Object.values(EVENTS).forEach(event => {
        document.removeEventListener(event, handleEvent);
      });
  }, []);

  return <ToastContainerToastify className={className} />;
};

ToastContainer.defaultProps = {
  className: '',
};

ToastContainer.propTypes = {
  className: PropTypes.string,
};

export default ToastContainer;
